import { render, staticRenderFns } from "./WorkshopClientRevGridCpt.vue?vue&type=template&id=79c802a2&scoped=true&"
import script from "./WorkshopClientRevGridCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopClientRevGridCpt.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopClientRevGridCpt.vue?vue&type=style&index=0&id=79c802a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c802a2",
  null
  
)

export default component.exports